import { createSelector } from 'reselect'
import { COMMENTS, OUTLINE } from './UrlPanelTypes'

export const getActiveOrganizationId = state =>
  (state.ui && state.ui.activeOrganizationId) || null

export const getActiveChannelId = state =>
  (state.ui && state.ui.activeChannelId) || null

export const getActiveUserId = state =>
  (state.ui && state.ui.activeUserId) || null

export const getActiveFilterId = state =>
  (state.ui && state.ui.activeFilterId) || null

export const getActiveNoteId = state => state.ui.activeNoteId
export const getActiveTemplateId = state => state.ui.activeTemplateId

export const getActiveModal = state =>
  (state.ui && state.ui.activeModal) || null

export const getActiveModalId = state =>
  (state.ui && state.ui.activeModal && state.ui.activeModal.id) || null

export const getWarningMessage = state => state.ui && state.ui.warningMessage

export const getActiveThreadId = state => state.ui && state.ui.activeThreadId

export const isSidebarChannelsListActive = state =>
  state.ui && state.ui.isSidebarChannelsListActive

export const isDirectEditingNote = state =>
  state.ui && state.ui.isDirectEditingNote

export const TOASTER_TYPES = {
  SUCCESS: 'SUCCESS',
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
}

export const getActiveToasterMessages = createSelector(
  state => state.ui.toasters,
  toasters => toasters.filter(toaster => !toaster.get('dismissedAt'))
)

export const CONNECTION_STATUSES_TYPE = {
  DISCONNECTED: 'DISCONNECTED',
  CONNECTED: 'CONNECTED',
  RECONNECTING: 'RECONNECTING',
}

export const getConnectionStatus = (state, type) =>
  state.ui.get('connectionStatuses').get(type)

export const getOutlineContainerId = state => {
  return state.ui.get('outlineContainerId')
}

export const getSelectedNoteIds = state => {
  return state.ui.get('selectedNoteIds')
}

export const isDetachedModeEnabled = state => {
  return state.ui.get('isDetachedModeEnabled')
}

export const isSearchModeEnabled = state => {
  return state.ui.get('isSearchModeEnabled')
}

export const isFocusModeEnabled = state => {
  return isSidebarCollapsed(state)
}

export const isSidebarCollapsed = state => state.ui.isSidebarCollapsed

export const isMetaPanelOpen = state => Boolean(state.ui.metaPanelType)
export const isCommentsOpen = state => state.ui.metaPanelType === COMMENTS
export const isOutlineOpen = state => state.ui.metaPanelType === OUTLINE

export const getRouteParams = state => state.ui.routeParams
